module.exports = __webpack_public_path__ + "static/media/PB_G_09.eb2dde09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/progress_bar/green/PB_G_09.png
// module id = 222
// module chunks = 0